const COOKIES = {
  IS_USER_LOGGED: 'is_user_logged',
  OFFERS_VIEW_MODE: 'offers_view_mode',
};

export default COOKIES;
